import { validateMediaFileAsync } from '../../../../media'

const getMediaKind = (file) => {
  const type = file?.type ?? file?.file?.type

  if (type?.startsWith('image/')) {
    return 'image'
  }

  if (type?.startsWith('video/')) {
    return 'video'
  }

  return null
}

export const validateGroupMediaType = (file, { groupImages, originalMedia, fileToReplaceId }, t) => {
  const newFileKind = getMediaKind(file)

  if (!newFileKind) {
    return t('common.errors.fileFormat')
  }

  let groupFiles = groupImages ?? []

  if (fileToReplaceId) {
    groupFiles = groupFiles.filter((item) => item.id !== fileToReplaceId)
  }

  // originalMedia is itself the item being replaced when the user picks
  // "replace" on the anchor card — must be excluded too, same as any
  // sibling in groupFiles, otherwise a 1-for-1 replace of the group's only
  // item falsely compares the new file against the very item it's replacing.
  const groupMembers =
    originalMedia && originalMedia.id !== fileToReplaceId
      ? [...groupFiles, originalMedia]
      : [...groupFiles]

  const hasImages = groupMembers.some((item) => getMediaKind(item) === 'image')
  const hasVideos = groupMembers.some((item) => getMediaKind(item) === 'video')

  if (hasImages && hasVideos) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  if (newFileKind === 'video' && hasImages) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  if (newFileKind === 'image' && hasVideos) {
    return t('Recommendations.campaign.setup.media.errors.formatMismatch', { fileName: file.name })
  }

  return null
}

export const handleMediaGroupSlotFileSelect = async (
  file,
  {
    groupId,
    ratio,
    requiredSlotRatios,
    isReplace,
    fileToReplaceId,
    groupImages,
    originalMedia,
    originalId,
    onAddToSlot,
    onReplaceInSlot,
    isGoogleOnly,
    isGoogleSelected,
    googleExactRatios,
    t,
  },
) => {
  if (!file) {
    return { error: null }
  }

  if (!file.path) {
    file.path = file.name
  }

  const formatError = validateGroupMediaType(
    file,
    { groupImages, originalMedia, fileToReplaceId: isReplace ? fileToReplaceId : null },
    t,
  )

  if (formatError) {
    return { error: formatError }
  }

  const validationError = await validateMediaFileAsync(file, { isGoogleOnly, isGoogleSelected, googleExactRatios, targetRatio: ratio, requiredSlotRatios, t })

  if (validationError) {
    return { error: validationError }
  }

  try {
    if (isReplace && fileToReplaceId) {
      await onReplaceInSlot?.(file, fileToReplaceId, ratio)
    } else {
      await onAddToSlot?.(file, groupId, ratio, originalId)
    }

    return { error: null }
  } catch (error) {
    return { error: error?.message || t('common.genericError') }
  }
}
